import { Checkbox, Collapse, Drawer, Radio, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { IoFilter } from "react-icons/io5";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Image from "../../assets/img/image.avif";
import PostApiCall from "../../Helper/PostApi";
import ProductCard from "../ProductCard/ProductCard";
import "./ProductListing.css";
import ProductCard1 from "../ProductCard/ProductCard1";
import { store } from "../../Helper/Context/Store";
import GetSeoData from "../../Helper/GetSeoData";
import Arrangements from "../../assets/img/inner banners/Arrangement.jpg";
import CakeAndChocolate from "../../assets/img/inner banners/Birthday,Cakes and Chocolates.jpg";
import BirthdayCombo from "../../assets/img/inner banners/Birthday,Combos.jpg";
import BirthdayFlowers from "../../assets/img/inner banners/Birthday,Flowers.jpg";
import Rakhi from "../../assets/img/inner banners/floral-hut-banner.png";
import AnniverseryFlowers from "../../assets/img/inner banners/Anniversary,Flowers.jpg";
import BirthdayBunches from "../../assets/img/inner banners/Birthday,Bunches,Flowers.jpg";
import MotherDaySpecial from "../../assets/img/inner banners/MotherDaySpecial.jpg";
import diwaliInner from "../../assets/img/inner banners/diwali-inner-banner.jpg";
import womensinner from "../../assets/img/inner banners/womensdayinnerbanner.png";
import mothersdayinnerbanner from "../../assets/img/inner banners/MOTHERS-DAY-INNER-BANNER.png";
import fatherdayinnerbanner from "../../assets/img/inner banners/father-day-inner-banner.png";
// import valentineinner from "../../assets/img/inner banners/valentineinner.png";

import noItem from "../../assets/img/item-not-found.png";

export default function ProductListing() {
  const params = useParams();
  const [innerBanner, setInnerBanner] = useState(null);
  const [mobileBanner, setMobileBanner] = useState(null);
  const { cartItems } = useContext(store);
  const [apiData, setApiData] = useState([]);
  const [allApiData, setAllApiData] = useState([]);
  const [productClass, setProductClass] = useState("col-6 col-lg-3 mb-4");
  const [open, setOpen] = useState(false);
  const [filteringData, setFilteringData] = useState([]);
  const [minimumValue, setMinimumValue] = useState(0);
  const [maximumValue, setMaximumValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [heading, setHeading] = useState("");
  const [catHeading, setCatHeading] = useState("");
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    getItems();
  }, [params.productcategoryname, params.categoryname]);
  const getItems = () => {
    PostApiCall.postRequest(
      {
        // categoryroute: params.productcategoryname,
        // verticalroute: params.categoryname,
        // stateid: null,
        subcatroute: params.subcatname
          ? `${params.categoryname}/${params.subcatname}`
          : "",
        verticleroute: params.subcatname ? "" : params.categoryname,
      },
      // "Get_All_Items"
      "GetSubCategoryItems",
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          const firstOrder = obj1.data
            .filter(
              (items) =>
                items.fld_verticlename?.toLowerCase() ===
                params.categoryname?.toLowerCase(),
            )
            .filter((item) => item?.fld_status == "Active");
          const secondOrder = obj1.data
            .filter(
              (items) =>
                items.fld_verticlename?.toLowerCase() !==
                params.categoryname?.toLowerCase(),
            )
            .filter((item) => item?.fld_status == "Active");
          const activeitems = [...firstOrder, ...secondOrder];

          setApiData(activeitems);
          setAllApiData(activeitems);
          setLoading(false);
          setMinimumValue(
            activeitems.length
              ? activeitems.reduce((max, product) =>
                  product.fld_mrp < max.fld_mrp ? product : max,
                )?.fld_mrp
              : 0,
            // activeitems.sort((a, b) => a?.fld_mrp - b?.fld_mrp)[0]?.fld_mrp
          );
          setMaximumValue(
            activeitems.length
              ? activeitems?.reduce((max, product) =>
                  product.fld_mrp > max.fld_mrp ? product : max,
                )?.fld_mrp
              : 0,
            // activeitems.sort((a, b) => b?.fld_mrp - a?.fld_mrp)[0]?.fld_mrp
          );
        }
      }),
    );
  };
  useEffect(() => {
    if (params.subcatname && params.subcatname === "mothers-day-special") {
      setInnerBanner(MotherDaySpecial);
      setHeading(
        "Make birthdays and special occasions even more memorable with our beautifully crafted flower bunches. Express your love and best wishes with fresh, vibrant blooms that add a touch of elegance and joy to every celebration.",
      );
    } else if (params.subcatname && params.subcatname === "diwali-8th-nov") {
      setInnerBanner(diwaliInner);
      setHeading(
        "Thoughtful Diwali gifts for everyone who matters, from family to colleagues.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "mothers-day-10th-may"
    ) {
      setInnerBanner(mothersdayinnerbanner);
      setHeading(
        "Make special occasions even more memorable with our beautifully crafted flower bunches. Express your love and best wishes with fresh, vibrant blooms that add a touch of elegance and joy to every celebration.",
      );
    } else if (params.subcatname && params.subcatname === "women-day-8th-mar") {
      setInnerBanner(womensinner);
      setHeading(
        "Celebrate Women’s Day with beautiful flower and gift combos.Choose elegant blooms to celebrate every special woman in your life.",
      );
    } else if (params.subcatname && params.subcatname === "easter-5th-apr") {
      setInnerBanner(BirthdayFlowers);
      setHeading(
        "Celebrate Easter with fresh flowers and thoughtful gift combos. Choose beautiful bouquets paired with chocolates and cakes to spread happiness and make your loved ones feel truly special on this joyful occasion.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "tamil-new-year-14th-apr"
    ) {
      setInnerBanner(BirthdayFlowers);
      setHeading(
        "Celebrate Tamil New Year with fresh flowers and delightful gift combos. Share beautiful bouquets paired with chocolates and cake combos to spread happiness, positivity and warm wishes among your loved ones.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "earth-day-22nd-apr"
    ) {
      setInnerBanner(BirthdayFlowers);
      setHeading(
        "Celebrate Earth Day with fresh flowers and gift combos. Send beautiful bouquets, chocolates and cake combos to share meaningful gifts and create happy moments with your loved ones.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "mothers-day-10th-may"
    ) {
      setInnerBanner(BirthdayFlowers);
      setHeading(
        "Celebrate Mother’s Day with fresh flowers and thoughtful gift combos. Surprise your mom with beautiful bouquets, chocolates and cakes to express your love and make her feel truly special.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "world-environment-day-5th-jun"
    ) {
      setInnerBanner(BirthdayFlowers);
      setHeading(
        "Celebrate World Environment Day with fresh flowers and gift combos. Choose lovely bouquets, chocolates and cakes to share joy and thoughtful gifts with your loved ones.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "fathers-day-21st-jun"
    ) {
      setInnerBanner(fatherdayinnerbanner);
      setHeading(
        "Celebrate Father’s Day with fresh flowers and gift combos. Give beautiful bouquets, chocolates and cakes to show your love and appreciation for your dad.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "national-doctors-day-1st-jul"
    ) {
      setInnerBanner(BirthdayFlowers);
      setHeading(
        "Celebrate Doctor’s Day with fresh flowers and gift combos. Thank doctors with beautiful bouquets, chocolates and cakes to show appreciation for their care and dedication.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "guru-purnima-29th-jul"
    ) {
      setInnerBanner(BirthdayFlowers);
      setHeading(
        "Celebrate Guru Purnima with fresh flowers and gift combos. Offer beautiful bouquets, chocolates and cakes to express respect and gratitude to your teachers and mentors.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "friendship-day-2nd-aug"
    ) {
      setInnerBanner(BirthdayFlowers);
      setHeading(
        "Celebrate Friendship Day with fresh flowers and gift combos. Surprise your friends with beautiful bouquets, chocolates and cakes to create joyful and memorable moments together.",
      );
    } else if (params.subcatname && params.subcatname === "onam-26th-aug") {
      setInnerBanner(BirthdayFlowers);
      setHeading(
        "This Onam, share the joy of the season with gorgeous blooms and thoughtful gifts that make your celebrations feel even more special.",
      );
    } else if (
      params.subcatname &&
      params.subcatname === "raksha-bandhan-28th-aug"
    ) {
      setInnerBanner(Rakhi);
      setHeading(
        "Celebrate Raksha Bandhan with fresh flowers and gift combos. Send beautiful bouquets with chocolates and cakes to your siblings to express love and strengthen your bond.",
      );
    } else {
      switch (params.categoryname) {
        case "flower-arrangement":
          setInnerBanner(Arrangements);
          setHeading(
            "Transform any space into a stunning celebration with our beautiful flower arrangements and expert decorations. From elegant bouquets to intricate setups, we create the perfect ambiance for every occasion, making your moments truly unforgettable.",
          );
          // setMobileBanner()
          break;
        case "bunches":
          setInnerBanner(BirthdayBunches);
          setHeading(
            "Express your gratitude and love with our gorgeous bunches of flowers, beautifully arranged to brighten any occasion. Whether it’s a birthday, anniversary, or simply to say “thank you”, these fresh, vibrant blooms are the perfect way to show you care. Each bouquet can be paired with a heartfelt thank-you note, adding a personal touch to your thoughtful gesture.",
          );
          break;
        case "cakes":
          setInnerBanner(CakeAndChocolate);
          setHeading(
            "Indulge in the sweetness of our freshly baked cakes, crafted to perfection for every occasion. Whether it’s a birthday, anniversary, or just because, our cakes are sure to add a special touch to your celebrations.",
          );
          break;
        case "combos":
          setInnerBanner(BirthdayCombo);
          setHeading(
            "Brighten their special moments with a gift that has it all! Our beautifully curated combos feature delicious cakes, beautiful flowers, and delightful chocolates—everything you need to create a truly memorable celebration.",
          );
          break;
        case "flowers":
          setInnerBanner(BirthdayFlowers);
          setHeading(
            "Make birthdays and special occasions even more memorable with our beautifully crafted flower bunches. Express your love and best wishes with fresh, vibrant blooms that add a touch of elegance and joy to every celebration.",
          );
          break;
        default:
          setHeading(
            "Brighten their special moments with a gift that has it all! Our beautifully curated combos feature delicious cakes, beautiful flowers and delightful chocolates—everything you need to create a truly memorable celebration.",
          );
          setInnerBanner(BirthdayFlowers);
      }
    }

    switch (params.categoryname) {
      case "birthday":
        setCatHeading(
          "Brighten their special moments with a gift that has it all! Our birthday cake and flowers combos include delicious cakes, fresh flowers, and sweet chocolates—everything you need for a truly memorable celebration.",
        );
        break;
      case "wedding":
        setCatHeading(
          "Celebrate love with the perfect wedding flower bouquet, crafted to add elegance and beauty to every moment. Our stunning arrangements bring freshness, charm, and a romantic touch to make any wedding truly unforgettable.",
        );
        break;
      case "anniversary":
        setCatHeading(
          "Make every milestone special with our Beautiful Anniversary Cake and Flowers, created to add sweetness and elegance to your celebration.",
        );
        break;
      case "flowers":
        setCatHeading(
          "Fresh Flowers for Gifting Online offer an easy way to send love and warm wishes. These beautifully arranged bouquets add charm to every occasion and make gifting simple, thoughtful, and memorable.",
        );
        break;
      case "flower-arrangement":
        setCatHeading(
          "Make gifting special with our Fresh Flower Arrangement for Gifting. Each arrangement is styled with vibrant, fresh blooms that bring joy, color, and warmth to any celebration.",
        );
        break;
      case "cakes":
        setCatHeading(
          "Make every celebration special with Delicious Cakes for Every Occasion. With online cake delivery in Chennai, sending fresh and yummy cakes to loved ones is easy and quick.",
        );
        break;
      case "chocolate":
        setCatHeading(
          "Delight your loved ones with a Chocolate and Flower Bouquet. This combo of fresh blooms and tasty chocolates is ideal for expressing love, care, and warm wishes.",
        );
        break;
      case "combos":
        setCatHeading(
          "Surprise your loved ones with our ready-to-send Combos. Each combo includes flowers, cakes, and gifts, creating a thoughtful and memorable present for any occasion.",
        );
        break;
      default:
        setCatHeading(
          "Brighten their special moments with a gift that has it all! Our beautifully curated combos feature delicious cakes, beautiful flowers, and delightful chocolates—everything you need to create a truly memorable celebration.",
        );
    }
  }, [params.productcategoryname]);

  const filterWithPrice = (value) => {
    const [first, last] = value
      .split(" to ")
      .map((str) => parseInt(str.trim()));

    const existingIndex = filteringData.findIndex(
      (item) => item.firstTerm === first && item.lastTerm === last,
    );

    if (existingIndex !== -1) {
      const updatedFilteringData = filteringData.filter(
        (item) => !(item.firstTerm === first && item.lastTerm === last),
      );

      if (updatedFilteringData.length === 0) {
        setApiData(allApiData);
      } else {
        const filteredData = allApiData.filter((item) =>
          updatedFilteringData.some(
            (range) =>
              item.fld_mrp >= range.firstTerm && item.fld_mrp <= range.lastTerm,
          ),
        );
        setApiData(filteredData);
        // console.log("Filtered Data after Removal:", filteredData);
      }
      setFilteringData(updatedFilteringData);
    } else {
      const updatedFilteringData = [
        ...filteringData,
        { firstTerm: first, lastTerm: last },
      ];

      const filteredData = allApiData.filter((item) =>
        updatedFilteringData.some(
          (range) =>
            item.fld_mrp >= range.firstTerm && item.fld_mrp <= range.lastTerm,
        ),
      );
      setApiData(filteredData);
      // console.log("Filtered Data after Addition:", filteredData);

      setFilteringData(updatedFilteringData);
    }

    // console.log("Current filteringData:", filteringData);
  };

  // const minimumValue = apiData.sort((a,b) => a.fld_mrp - b.fld_mrp)[0].fld_mrp;
  // const maximumValue = apiData.sort((a,b) => b.fld_mrp - a.fld_mrp)[0].fld_mrp;

  const items = [
    {
      label: "Price",
      key: "1",
      children: (
        <div className="d-flex flex-column gap-2">
          <Checkbox
            onClick={(e) => filterWithPrice(e.target.value)}
            value={`${minimumValue} to ${minimumValue + 500}`}>
            ₹ {minimumValue} TO ₹ {minimumValue + 500}{" "}
          </Checkbox>
          <Checkbox
            onClick={(e) => filterWithPrice(e.target.value)}
            value={`${minimumValue + 500} to ${maximumValue - 500}`}>
            ₹ {minimumValue + 500} TO ₹ {maximumValue - 500}
          </Checkbox>
          <Checkbox
            onClick={(e) => filterWithPrice(e.target.value)}
            value={`${maximumValue - 500} to ${maximumValue}`}>
            ₹ {maximumValue - 500} TO ₹ {maximumValue}{" "}
          </Checkbox>
        </div>
      ),
    },
    // {
    //   label: "Flower Type",
    //   key: "2",
    //   children: (
    //     <div className="d-flex flex-column gap-2">
    //       <Radio>Roses (277)</Radio>
    //       <Radio>Roses (277)</Radio>
    //     </div>
    //   ),
    // },
    // {
    //   label: "Color",
    //   key: "3",
    //   children: (
    //     <div className="d-flex flex-column gap-2">
    //       <Radio>Red (134)</Radio>
    //       <Radio>Red (134)</Radio>
    //     </div>
    //   ),
    // },
  ];
  // const handleMenuClick = (e) => {
  //   message.info("Click on menu item.");
  //   console.log("click", e);
  // };
  // const menuProps = {
  //   items,
  //   onClick: handleMenuClick,
  // };
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <section className="section-spacing-x section-spacing-x-mobile">
      <GetSeoData
        type={params.subcatname ? "SubCategory" : "Vertical"}
        id={null}
        route={
          params.subcatname
            ? `${params.categoryname}/${params.subcatname}`
            : params.categoryname
        }
      />

      <div className="container-fluid">
        <div className="row my-4">
          <div className="col-12">
            <img src={innerBanner} className="img-fluid w-100" alt="" />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {loading === false ? (
              <div>
                <h1 className="main-heading text-center mb-lg-0">
                  {params?.subcatname
                    ? apiData[0]?.fld_subcategoryname
                    : params?.categoryname
                        ?.replace(/-/g, " ")
                        .split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ")}
                </h1>
                <p className=" text-center">
                  {apiData.length !== 0 &&
                    (params?.subcatname ? heading : catHeading)}
                </p>
              </div>
            ) : (
              <div>
                <h1 className="main-heading text-center mb-lg-0">
                  <Skeleton.Input />
                </h1>
                {/* <h4 className="text-center my-2"><Skeleton.Input /></h4> */}
              </div>
            )}
            {apiData.length !== 0 && (
              <div className="d-flex justify-content-end align-items-center mb-4">
                <button
                  className="theme-btn border-0 px-2 py-1"
                  onClick={showDrawer}>
                  <IoFilter className="me-2" />
                  Filter
                </button>
              </div>
            )}
          </div>
          {loading === false ? (
            <>
              {apiData.length !== 0 ? (
                <>
                  {apiData.map((val, index) => {
                    const isCart = cartItems.find((item) => {
                      if (val.fld_variantid === item.fld_variantid) {
                        return item;
                      }
                      return false;
                    });
                    return (
                      <div key={index} className={productClass}>
                        <ProductCard1 productData={val} isInCart={isCart} />
                      </div>
                    );
                  })}
                  {/* {(!params.subcatname && params.categoryname) && <div className="col-12"> */}
                  {apiData[0]?.fld_description && (
                    <div className="col-12">
                      <div
                        className="dynamic-content"
                        dangerouslySetInnerHTML={{
                          __html: apiData[0]?.fld_description,
                        }}
                      />
                    </div>
                  )}
                </>
              ) : (
                <div className="d-flex flex-column align-items-center justify-content-center my-5 pb-5">
                  <img className="img-fluid mb-4" src={noItem} />
                  <h3 className="mb-5">
                    Product you are looking for, is not found.
                  </h3>
                </div>
              )}
            </>
          ) : (
            <div className="row w-100 mb-lg-5 mx-0 exclusive-offers-box">
              <div className={`col-6 col-lg-3 mb-4 mb-lg-0`}>
                <div className="product-img-skeleton">
                  <Skeleton.Image className="h-100 w-100" />
                  <div className="buttons flex-column detailsbtn mb-0">
                    <h2 className="prod-price">
                      <Skeleton.Button />
                    </h2>
                  </div>
                  <div className="mt-3">
                    <Skeleton.Input />
                  </div>
                </div>
              </div>
              <div className={`col-6 col-lg-3 mb-4 mb-lg-0`}>
                <div className="product-img-skeleton">
                  <Skeleton.Image className="h-100 w-100" />
                  <div className="buttons flex-column detailsbtn mb-0">
                    <h2 className="prod-price">
                      <Skeleton.Button />
                    </h2>
                  </div>
                  <div className="mt-3">
                    <Skeleton.Input />
                  </div>
                </div>
              </div>
              <div className={`col-6 col-lg-3 mb-4 mb-lg-0 d-none d-md-block`}>
                <div className="product-img-skeleton">
                  <Skeleton.Image className="h-100 w-100" />
                  <div className="buttons flex-column detailsbtn mb-0">
                    <h2 className="prod-price">
                      <Skeleton.Button />
                    </h2>
                  </div>
                  <div className="mt-3">
                    <Skeleton.Input />
                  </div>
                </div>
              </div>
              <div className={`col-6 col-lg-3 mb-4 mb-lg-0 d-none d-md-block`}>
                <div className="product-img-skeleton">
                  <Skeleton.Image className="h-100 w-100" />
                  <div className="buttons flex-column detailsbtn mb-0">
                    <h2 className="prod-price">
                      <Skeleton.Button />
                    </h2>
                  </div>
                  <div className="mt-3">
                    <Skeleton.Input />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Drawer
        title="Filters"
        onClose={onClose}
        open={open}
        width={500}
        className="filter-drawer">
        <Collapse accordion items={items} />
      </Drawer>
    </section>
  );
}
